import { useDispatch, useSelector } from "react-redux";
import { clearSelectedUser, clearTypeOfOpen, clearUpdatePassword, resetCreateNewStaff, selectCreateNewStaff, selectCurrentStaffId, selectTypeOfOpen, selectUpdatePassword } from "../../features/user/userSlice";
import { CreateNewStaff, UpdateInfoUser } from "../../types/user";
import { UpdateUserInfoRequest } from "../../types/request";
import { useMutationData } from "../api/useMutationData";
import { selectCurrentUserId } from "../../features/auth/authSlice";
import { showToast } from "../../toastify/Toast";
import { handleApiError } from "../../utils/handleApiError";
import { clearTypeModal, clearTypeOfShowModalType, selectCurrentModalType, setTypeOfShowModalType } from "../../features/modal/modalSlice";

export default function useUserAction() {
    
    const dispatch = useDispatch();
    const createNewStaffState = useSelector(selectCreateNewStaff);
    const typeOfOpenAction = useSelector(selectTypeOfOpen);
    const currentLogUserId = useSelector(selectCurrentUserId);
    const updatePassword = useSelector(selectUpdatePassword)
    const typeModal = useSelector(selectCurrentModalType);
    const staffId = useSelector(selectCurrentStaffId);
    // const { userInfo } = useQueryData()
    // const { roles, status } = useStaffMeta();
    // const { populateStaffInfo } = useStaffPopulate(userInfo, roles, status);
    const { updateMyAccountInfo, createNewStaff, updateStaff } = useMutationData()
    const isActionTypeName = typeOfOpenAction === 'name';
    const isActionTypePassword = typeOfOpenAction === 'password';

    const handleUpdateProfileDetails = async () => {
        
        if(!createNewStaffState || !currentLogUserId) return
        try {
            if(isActionTypeName) {
                const updateInfo: UpdateInfoUser = {
                    firstName: createNewStaffState.firstName,
                    middleInitial: createNewStaffState.middleInitial ?? '',
                    lastName: createNewStaffState.lastName,
                };

                const payload: UpdateUserInfoRequest = {
                    staffID: currentLogUserId,
                    info: updateInfo,
                };
                await updateMyAccountInfo(payload).unwrap();
            }
            if(isActionTypePassword) {
                if(!updatePassword.newPass || !updatePassword.oldPass) {
                    return showToast("Please fill in all required fields.", "error")
                }

                const updateInfo: UpdateInfoUser = {
                    oldPassword: updatePassword.oldPass,
                    newPassword: updatePassword.newPass,
                };

                const payload: UpdateUserInfoRequest = {
                    staffID: currentLogUserId ?? 0,
                    info: updateInfo,
                };

                await updateMyAccountInfo(payload).unwrap();
                dispatch(clearUpdatePassword())
            }
            dispatch(clearTypeOfOpen())
            showToast("Profile updated successfully.", "success");
        } catch (error) {
            handleApiError(error, "Failed to update profile.");
        }
    }

    const handleCloseViewAndUpdateUserDetails = () => {
        dispatch(setTypeOfShowModalType("viewProfileDetails"))
        dispatch(clearTypeOfOpen())
        dispatch(clearUpdatePassword())
        // populateStaffInfo();
    }
    
    const handleCancelUpdateProfile = () => {
        dispatch(clearTypeOfOpen())
        dispatch(clearUpdatePassword())
        // populateStaffInfo();
    }

    const handleSaveNewStaff = async () => {
        if(typeModal === null) return
        if(typeModal !== 'newStaff' && typeModal !== 'updateStaff') return
        
        if(createNewStaffState?.role?.roleId === 0) {
            showToast("Please select a different role.", "error");
            return;
        }

        if(createNewStaffState?.status?.statusId === 0) {
            showToast("Please select a different status.", "error");
            return;
        }

        if(!createNewStaffState) return
        const newStaffData: CreateNewStaff = { 
            firstName: createNewStaffState.firstName,
            lastName: createNewStaffState.lastName,
            middleInitial: createNewStaffState.middleInitial,
            email: createNewStaffState.email,
            roleId: createNewStaffState.role?.roleId || 0,
            password: createNewStaffState.password,
            statusId: 1
        };

        const UpdateStaffData: CreateNewStaff = { 
            firstName: createNewStaffState.firstName,
            lastName: createNewStaffState.lastName,
            middleInitial: createNewStaffState.middleInitial,
            email: createNewStaffState.email,
            roleId: createNewStaffState.role?.roleId || 0,
            password: createNewStaffState.password,
            statusId: createNewStaffState.status?.statusId || 0
        };
        try {
            if(typeModal === 'newStaff') {
                await createNewStaff(newStaffData).unwrap();
                showToast("New staff added successfully!", 'success')
            }
            if(typeModal === 'updateStaff') {
                if(!staffId) {
                    return
                }
                await updateStaff({ staffId, data: UpdateStaffData}).unwrap();
                showToast("Staff updated successfully!", 'success')
            }
            dispatch(clearTypeModal());
            dispatch(clearSelectedUser());
            dispatch(clearTypeOfShowModalType())
            dispatch(resetCreateNewStaff())
        } catch (error) {
            handleApiError(error, "Something went wrong. Please try again.");
        }
    }
    

    return {
        handleUpdateProfileDetails,
        handleCloseViewAndUpdateUserDetails,
        handleCancelUpdateProfile,

        handleSaveNewStaff,
    }
}